import React from 'react';
import constants from 'utils/constants'
import { SampleProofSection, SectionTitle, TextBox, ProofList, ImgWrapper, ImgInnerWrapper,SampleProofImg, TodolistBtnWrapper, TodolistBtn, TodolistBtnTxt, GreyTodolistBtn, GreyTodolistBtnTxt } from './style';
import styled from 'styled-components';
export default function ChallengeSampleProof({proofList, type}) {
    let imgPath = (type === "campaign") ? constants['imagePath'] +"/campaign_sample_proof_img/" : constants['imagePath'] +"/group_project_sample_proof_img/";

    return(
        <SampleProofSection>
            <SectionTitle>어떻게 인증하나요?</SectionTitle>
            <TextBox>
                <ProofList> 
                { 
                    (proofList)?proofList.map((value,index)=>{
                        return  (
                            <ImgWrapper width={(proofList?.length < 3)?'50%':null} className={'img-wrapper'}  key={`proof-img-list-item-${index}`}> 
                                <SampleProofImg src={imgPath+value} /> 
                            </ImgWrapper>
                        )
                    })
                    :null
                }  
                </ProofList>
            </TextBox> 
        </SampleProofSection>
    );
}


